import { useCallback } from 'react';
import useMutationsCount from './useMutationsCount';

const useDeepCallback = (callback, deps) => {	
	const mutationCount = useMutationsCount(deps);	
    return useCallback(callback, [mutationCount]);
};

export default useDeepCallback;
